import { useState, useEffect } from 'react';
import {WarnIcon} from '../Icons/icons'
import '../Veilleur/veilleur.css';

 export function ModalUrgence({ onClose }) {
  const urgences = [
    { id: 'gendarmerie', icon: '🚔', label: 'Gendarmerie', num: '17' },
    { id: 'samu',        icon: '🚑', label: 'SAMU',        num: '15' },
    { id: 'pompiers',    icon: '🚒', label: 'Pompiers',    num: '18' },
    { id: 'responsable', icon: '👤', label: 'Responsable', num: 'Appeler' },
  ];
  return (
    <div className="vv-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="vv-modal" style={{ maxWidth: 420 }}>
        <div className="vv-modal-header">
          <div className="vv-modal-title" style={{ color: '#f87171' }}>
            <WarnIcon /> Appels d'urgence
          </div>
          <button className="vv-modal-close" onClick={onClose}>×</button>
        </div>
        <p style={{ fontSize: '12px', color: 'var(--pg-text-muted)', marginBottom: '0.5rem' }}>
          Appel direct — 1 clic
        </p>
        <div className="vv-urgence-grid">
          {urgences.map(u => (
            <div
              key={u.id}
              className={`vv-urgence-card ${u.id}`}
              onClick={() => { window.location.href = `tel:${u.num}`; }}
            >
              <span className="vv-urgence-icon">{u.icon}</span>
              <span className="vv-urgence-label">{u.label}</span>
              <span className="vv-urgence-num">{u.num}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}